import { DialogContent, Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import {
  BottomSheet,
  Illustration,
  Text,
  Title,
  type UseModalState,
} from "@src/appV2/redesign/system/ui-components";

interface JobSearchAgreementConfirmationModalProps {
  modalState: UseModalState;
  onContinueBooking: () => Promise<void>;
}

export function JobSearchAgreementConfirmationModal(
  props: JobSearchAgreementConfirmationModalProps
) {
  const { modalState, onContinueBooking } = props;

  return (
    <BottomSheet
      modalState={modalState}
      canDismiss={false}
      footer={
        <DialogFooter orientation="vertical">
          <Button
            fullWidth
            size="large"
            variant="contained"
            onClick={async () => {
              await onContinueBooking();
            }}
          >
            Continue my booking
          </Button>
        </DialogFooter>
      }
    >
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          paddingTop: 9,
        }}
      >
        <Stack alignItems="center" spacing={8} sx={{ px: 2 }}>
          <Illustration type="success" />
          <Title variant="h3" component="h3" sx={{ textAlign: "center" }}>
            Agreement signed
          </Title>
          <Text align="center">
            You may access a copy of your Job Search Agreement in the Accounts tab.
          </Text>
        </Stack>
      </DialogContent>
    </BottomSheet>
  );
}
